module.exports = __webpack_public_path__ + "823a75f7ba4a7e02b8a562f6eb31c029.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/hand/pizza.png
// module id = 2709
// module chunks = 0